export const Keys = Object.freeze({
  FEEDBACK_IDS: 'feedbackIds',
  ALL_THUMBED_TRACKS: 'allThumbedTracks',
  FETCHED_DATA_SUCCESS_KEY: 'fetchedDataSuccess',
  FETCHING_OFFSETS: 'FETCHING_OFFSETS',
  FETCHED_OFFSETS: 'FETCHED_OFFSETS',
  THUMBED_TRACKS: 'THUMBED_TRACKS',
} as const);
